import React from 'react'

const RemovePercentBtn = ({percent,clickPercentBtn}) => {
  return (
    <button onClick={()=>clickPercentBtn(percent)}>{percent*100}%</button>
  )
}

export default RemovePercentBtn